export default __webpack_public_path__ + "static/media/icon7.b9c8aca2.svg";